import PrimaryCardContent from './PrimaryCardContent';

export default PrimaryCardContent;
